module.exports = __webpack_public_path__ + "img/closeIconBlue.887ac952.svg";